/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    ERR_V2_REQUIRED,
    ERR_RATE_LIMIT_EXCEEDED,
    ERR_YOU_LOOK_FAMILIAR,
    ERR_YOU_LOOK_FAMILIAR_TOUR,
    ERR_BUSY,
    ERR_CHALLENGE_FAILED,
    ERR_NO_LONGER_AVAILABLE,
    ERR_TOUR_INSTANCE_CLOSED,
    ERR_ADVANCED_RESERVATION,
} from '../constants';

/**
 *
 * Take the server error and turn it into the new happy UX error. Hopefully one day
 * we'll just update the server errors and this can go away
 *
 */
export const convertServerErrorToDisplayError = (errorMsg) => {
    // Overbooking error (You look familiar ...)
    if (
        errorMsg.includes(ERR_YOU_LOOK_FAMILIAR) ||
        errorMsg.includes(ERR_YOU_LOOK_FAMILIAR_TOUR)
    ) {
        const ticketAllowance = errorMsg.substring(19, errorMsg.indexOf('. Please try'));

        return `${ticketAllowance}. You may see this error if you already have a reservation in your cart. <a class="rec-button-link" title="Check your cart" aria-label="Check your cart" href="/cart" target="_blank" rel="noreferrer">Check your cart</a> to confirm if your order is waiting for purchase, or check your account to confirm that you don't have a reservation for this date.`;
    }

    // Recaptcha v2 required ... don't show this - it just opens the modal
    if (errorMsg === ERR_V2_REQUIRED) {
        return null;
    }

    // tour is in a closure process
    if (errorMsg === ERR_TOUR_INSTANCE_CLOSED) {
        return 'This facility is currently processing a closure for the date of your reservation. Please check your email inbox shortly for more details about your cancelled reservation';
    }

    // Captcha fail error
    if (errorMsg === ERR_CHALLENGE_FAILED) {
        return 'We were unable to verify that you are a human. Please refresh your browser and try again.';
    }
    // Rate limit hit
    if (errorMsg === ERR_RATE_LIMIT_EXCEEDED || errorMsg === ERR_BUSY) {
        return 'Too many people are requesting this item at this time.';
    }
    // Inventory no longer available
    if (errorMsg.includes(ERR_NO_LONGER_AVAILABLE)) {
        return 'The tickets you’ve selected are no longer available. Please select a different date and/or time.';
    }

    // For advanced reservation errors, we show whatever error message the backend sends.
    if (errorMsg.includes(ERR_ADVANCED_RESERVATION)) {
        return `${errorMsg}`;
    }

    // Catch-all
    return `${errorMsg} - Please try refreshing the page and adding your reservation again.`;
};
